import { IPiece, ISquare } from "./types";

export class Square implements ISquare {
  constructor(pieces: IPiece[]) {
    this.Pieces = pieces;
  }
  Pieces: IPiece[];
}
